"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.flagsImpl = void 0;
/**
 * groupBy list of variant instances. Assumes one object per variation.
 * @param key
 */
function flagsImpl(key) {
    function flags(flags) {
        return flags.reduce((o, v) => (Object.assign(Object.assign({}, o), { [v[key]]: v })), Object.create(null));
    }
    return { flags };
}
exports.flagsImpl = flagsImpl;
